global.ArGlob = {
    ContactEmaiEndPoint: "https://blljnj3s51.execute-api.ap-northeast-1.amazonaws.com/arbsip-contact-email-main"
    // ContactEmaiEndPoint: "https://a5e3owvnm3.execute-api.ap-northeast-1.amazonaws.com/arbsip-contact-email-dev"
};